import { Card, Row, Col, Statistic, Button } from 'antd'
import {
  SafetyCertificateOutlined,
  TeamOutlined,
  BankOutlined,
  ClockCircleOutlined,
  PlusOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'

export const PermissionDashboard = () => {
  const navigate = useNavigate()

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <h1>Permission Management</h1>
        <p>Centralized hub for managing user-hospital permissions</p>
      </div>

      {/* Statistics Cards */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <Card>
            <Statistic title="Total Permissions" value={0} prefix={<SafetyCertificateOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Active Users" value={0} prefix={<TeamOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Hospitals" value={0} prefix={<BankOutlined />} />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic title="Recent Changes (24h)" value={0} prefix={<ClockCircleOutlined />} />
          </Card>
        </Col>
      </Row>

      {/* Quick Actions */}
      <Card title="Quick Actions" style={{ marginBottom: 24 }}>
        <Row gutter={16}>
          <Col span={8}>
            <Button
              type="primary"
              size="large"
              icon={<PlusOutlined />}
              block
              onClick={() => navigate('/permissions/users')}
            >
              Manage User Permissions
            </Button>
            <p style={{ marginTop: 8, color: '#666' }}>
              View and modify permissions for individual users
            </p>
          </Col>
          <Col span={8}>
            <Button
              size="large"
              icon={<BankOutlined />}
              block
              onClick={() => navigate('/permissions/hospitals')}
            >
              Manage Hospital Access
            </Button>
            <p style={{ marginTop: 8, color: '#666' }}>
              See all users with access to specific hospitals
            </p>
          </Col>
          <Col span={8}>
            <Button
              size="large"
              icon={<ThunderboltOutlined />}
              block
              onClick={() => navigate('/permissions/bulk')}
            >
              Bulk Operations
            </Button>
            <p style={{ marginTop: 8, color: '#666' }}>
              Grant or revoke permissions for multiple users
            </p>
          </Col>
        </Row>
      </Card>

      {/* Recent Activity Placeholder */}
      <Card title="Recent Permission Changes">
        <p style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
          Recent activity feed coming soon
        </p>
      </Card>
    </div>
  )
}
